import React, { useContext } from "react";
import classname from "classname";
import { useTranslation } from "react-i18next";
import { DataUrlStoreContext } from "../loadData";

export const Tags = ({ tags, tagCloudTitle, maxTagsCount }) => {
    const DataUrlStore = useContext(DataUrlStoreContext);

    if (!tags || tags.length === 0) {
        return null;
    }
    tags.sort((tag1, tag2) => tag2.postCount - tag1.postCount);

    const filteredTags = tags.filter((tag, i) => {
        if (!maxTagsCount) {
            return true;
        } else {
            return i < maxTagsCount;
        }
    })

    const selectedTag = DataUrlStore.useState(state => state.tag);
    const { t } = useTranslation();
    return <div className="scp-embed-tagcloud-container scp-p-4 scp-rounded-sm scp-shadow-md scp-embed-block scp-flex scp-flex-col scp-gap-4">
        <div className="scp-embed-tag-title scp-text-xl">{tagCloudTitle || t('popular_tags')}</div>
        <div className="scp-flex scp-gap-2 scp-flex-wrap">
            {
                filteredTags.map((tag, i) => <Tag key={i} name={tag.tag} postCount={tag.postCount} selected={tag.tag === selectedTag} />)
            }
        </div>
    </div>
}

const Tag = ({ name, postCount, selected }) => {
    const DataUrlStore = useContext(DataUrlStoreContext);

    return <div
        className={classname(
            "scp-flex scp-border scp-border-solid scp-border-blueGray-400 scp-embed-tag scp-rounded-sm scp-cursor-pointer",
            {
                "scp-embed-tag-selected scp-bg-blueGray-400 scp-text-white": selected,
            }
        )}
        onClick={function () {
            DataUrlStore.update(function (state) {
                if (selected) {
                    state.tag = null;
                } else {
                    state.tag = name;
                }
                state.data_url = state.next_data_url;
            })
        }}
    >
        <div className="scp-embed-tag-count scp-py-0.5 scp-px-2">
            {name}
        </div>
        <div className={"scp-py-0.5 scp-px-2 scp-bg-blueGray-400 scp-text-white"}>{postCount}</div>
    </div>
}

